"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyEmailPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var apply_action_code_1 = require("../../../api/calls/user/authentication/apply_action_code");
var VerifyEmailPage = function () {
    var params = (0, react_router_dom_1.useParams)();
    var _a = (0, react_1.useState)(true), isLoading = _a[0], setIsLoading = _a[1];
    var resetCode = params.resetCode;
    var _b = (0, react_1.useState)({
        title: "",
        message: "",
    }), responses = _b[0], setResponses = _b[1];
    (0, react_1.useEffect)(function () {
        if (resetCode) {
            (0, apply_action_code_1.apply_action_code)({
                code: resetCode,
            }).then(function (response) {
                if (response.success) {
                    setResponses({
                        title: "Email Verified!",
                        message: "Your email has been successfully verified! You now have full access to your account and all its features",
                    });
                    setIsLoading(false);
                }
                else {
                    setIsLoading(false);
                    setResponses({
                        title: "Email Verification Failed!",
                        message: response.message,
                    });
                }
            });
        }
    }, [resetCode]);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement("div", { className: "relative" },
            react_1.default.createElement("div", { className: "flex flex-row justify-center" },
                react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null, isLoading ? (react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null)) : (react_1.default.createElement("div", null,
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: responses.title, textColor: "text-black", size: "2xlarge", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: responses.message, textColor: "text-secondary", size: "medium", bold: true }))))))));
};
exports.VerifyEmailPage = VerifyEmailPage;
